import type { ThemeDefinition } from 'vuetify'

export const staticPrimaryColor = '#000000'
export const staticPrimaryDarkenColor = '#292929c5'

export const themes: Record<string, ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      'primary': staticPrimaryColor,
      'wb': '#7d256f',
      'telegram':'#0088cc',
      'support':'#8652f3',
      'on-primary': '#fff',
      'primary-darken-1': '#292929c5',
      'secondary': '#808390',
      'on-secondary': '#fff',
      'secondary-darken-1': '#737682',
      'success': '#28C76F',
      'on-success': '#fff',
      'success-darken-1': '#24B364',
      'info': '#00BAD1',
      'on-info': '#fff',
      'info-darken-1': '#00A7BC',
      'warning': '#FF9F43',
      'on-warning': '#fff',
      'warning-darken-1': '#E68F3C',
      'error': '#FF4C51',
      'on-error': '#fff',
      'error-darken-1': '#E64449',
      'background': '#F8F7FA',
      'on-background': '#000000',
      'surface': '#fff',
      'on-surface': '#000000',
      'grey-50': '#FAFAFA',
      'grey-100': '#F5F5F5',
      'grey-200': '#EEEEEE',
      'grey-300': '#E0E0E0',
      'grey-400': '#BDBDBD',
      'grey-500': '#9E9E9E',
      'grey-600': '#757575',
      'grey-700': '#616161',
      'grey-800': '#424242',
      'grey-900': '#212121',
      'grey-light': '#FAFAFA',
      'perfect-scrollbar-thumb': '#DBDADE',
      'skin-bordered-background': '#fff',
      'skin-bordered-surface': '#fff',
      'expansion-panel-text-custom-bg': '#fafafa',
    },

    variables: {
      'code-color': '#d400ff',
      'overlay-scrim-background': '#2F2B3D',
      'tooltip-background': '#2F2B3D',
      'overlay-scrim-opacity': 0.5,
      'hover-opacity': 0.06,
      'focus-opacity': 0.1,
      'selected-opacity': 0.08,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.4,
      'border-color': '#2F2B3D',
      'border-opacity': 0.12,
      'table-header-color': '#EAEAEC',
      'high-emphasis-opacity': 0.9,
      'medium-emphasis-opacity': 1,
      'switch-opacity': 0.2,
      'switch-disabled-track-opacity': 0.3,
      'switch-disabled-thumb-opacity': 0.4,
      'switch-checked-disabled-opacity': 0.3,
      'track-bg': '#F1F0F2',

      // Shadows
      'shadow-key-umbra-color': '#2F2B3D',
      'shadow-xs-opacity': 0.10,
      'shadow-sm-opacity': 0.12,
      'shadow-md-opacity': 0.14,
      'shadow-lg-opacity': 0.16,
      'shadow-xl-opacity': 0.18,
    },
  },
  dark: {
    dark: true,
    colors: {
      'primary': '#6366F1',
      'wb': '#C084FC',
      'telegram': '#60A5FA',
      'support': '#A78BFA',
      'on-primary': '#FFFFFF',
      'primary-darken-1': '#4F46E5',
      'secondary': '#8B5CF6',
      'on-secondary': '#FFFFFF',
      'secondary-darken-1': '#7C3AED',
      'success': '#22C55E',
      'on-success': '#FFFFFF',
      'success-darken-1': '#16A34A',
      'info': '#3B82F6',
      'on-info': '#FFFFFF',
      'info-darken-1': '#2563EB',
      'warning': '#F59E0B',
      'on-warning': '#FFFFFF',
      'warning-darken-1': '#D97706',
      'error': '#EF4444',
      'on-error': '#FFFFFF',
      'error-darken-1': '#DC2626',
      'background': '#0F172A',
      'on-background': '#F1F5F9',
      'surface': '#1E293B',
      'on-surface': '#E2E8F0',
      'grey-50': '#0F1419',
      'grey-100': '#1E293B',
      'grey-200': '#334155',
      'grey-300': '#475569',
      'grey-400': '#64748B',
      'grey-500': '#94A3B8',
      'grey-600': '#CBD5E1',
      'grey-700': '#E2E8F0',
      'grey-800': '#F1F5F9',
      'grey-900': '#F8FAFC',
      'grey-light': '#334155',
      'perfect-scrollbar-thumb': '#475569',
      'skin-bordered-background': '#1E293B',
      'skin-bordered-surface': '#252F3F',
      'expansion-panel-text-custom-bg': '#1E293B',
    },
    variables: {
      'code-color': '#A78BFA',
      'overlay-scrim-background': '#020617',
      'tooltip-background': '#334155',
      'overlay-scrim-opacity': 0.8,
      'hover-opacity': 0.1,
      'focus-opacity': 0.15,
      'selected-opacity': 0.12,
      'activated-opacity': 0.2,
      'pressed-opacity': 0.18,
      'dragged-opacity': 0.14,
      'disabled-opacity': 0.35,
      'border-color': '#475569',
      'border-opacity': 0.25,
      'table-header-color': '#334155',
      'high-emphasis-opacity': 0.98,
      'medium-emphasis-opacity': 0.8,
      'switch-opacity': 0.6,
      'switch-disabled-track-opacity': 0.25,
      'switch-disabled-thumb-opacity': 0.4,
      'switch-checked-disabled-opacity': 0.35,
      'track-bg': '#334155',

      // Shadows - более глубокие и выразительные
      'shadow-key-umbra-color': '#000000',
      'shadow-xs-opacity': 0.35,
      'shadow-sm-opacity': 0.4,
      'shadow-md-opacity': 0.45,
      'shadow-lg-opacity': 0.5,
      'shadow-xl-opacity': 0.55,
    },
  },
}

export default themes
